export const track = (eventBody: Record<string, any>): boolean => {
  // @ts-ignore
  if (window.dataLayer) {
    // @ts-ignore
    return dataLayer.push(eventBody);
  }
  return false;
};

export const trackAppSession = (): boolean => {
  return track({ event: "signupFromApp", inApp: true });
};
